/* tslint:disable */
 
import { FileModel } from './file-model';
import { ReferenceProperty } from './reference-property';
export class DataEntryEmailDto {
  attachments: Array<null | FileModel>;
  bcc?: Array<string>;

  /**
   * The email body.
   */
  body: string;
  cc?: Array<string>;

  /**
   * The from email address of the email.
   */
  from: string;

  /**
   * The generated at date time.
   */
  generatedAt: string;
  generatedBy: ReferenceProperty;

  /**
   * The related trigger execution id.
   */
  relatedTriggerExecutionId: string;

  /**
   * Whether the email is generated by background reactions or UI reaction.
   */
  source?: 0 | 1;

  /**
   * The email subject.
   */
  subject: string;
  to: Array<string>;

  [key: string]: any;
}
